module.exports = __webpack_public_path__ + "img/produktbroschuren_de.a80c795a.png";